<!-- src/App.vue -->

<template>
  <router-view />
</template>

<script>
export default {
  name: 'App',
};
</script>

<!-- No <style> section since all styles are in global.css -->
